module.exports = __webpack_public_path__ + "static/media/truck_icon.b352ef3b.svg";